import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UploadLinkListFieldsFragment = { __typename?: 'UploadLink', id?: string | null, name?: string | null, url?: string | null, creator?: { __typename?: 'AuthenticatedUser', id: string, name?: string | null } | null };

export const UploadLinkListFields = /*#__PURE__*/ gql`
    fragment UploadLinkListFields on UploadLink {
  id
  name
  url
  creator {
    id
    name
  }
}
    ` as unknown as DocumentNode<UploadLinkListFieldsFragment, unknown>;

        

        
export const useUploadLinkListFieldsFragment = (
  input: string | Omit<UseFragmentOptions<UploadLinkListFieldsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'UploadLink' } };
    return input;
  })();

  return useFragment<UploadLinkListFieldsFragment>({
    fragment: UploadLinkListFields,
    fragmentName: 'UploadLinkListFields',
    ...options,
  });
};
  
        